/**
 * Host-local "Rate clues" preference (#201, D201.12).
 *
 * The clue-rating feature is enabled by the host at game creation via a checkbox, and that
 * choice is **host-client-local only** — it is deliberately NOT part of `GameState` and
 * never rides the wire (no `PROTOCOL_VERSION` change): only the host rates, so only the
 * host's own browser needs to know. Persisted in `localStorage` (like {@link ./host-session})
 * so it survives a reload and defaults the checkbox to the host's last choice. Default OFF.
 */

const RATE_CLUES_KEY = 'jeopardy.host.rateClues';

/** Read whether the host enabled clue rating (default OFF). */
export function loadRateCluesEnabled(): boolean {
  try {
    return localStorage.getItem(RATE_CLUES_KEY) === 'true';
  } catch {
    // A storage-blocked context (private mode / SSR) just falls back to OFF.
    return false;
  }
}

/** Persist the host's clue-rating enable choice. */
export function saveRateCluesEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(RATE_CLUES_KEY, enabled ? 'true' : 'false');
  } catch {
    // Best-effort — a storage-blocked context simply won't remember the choice.
  }
}
